(function (angular) {
    'use strict';

    angular.module('chat2')

        /**
         *
         */
        .factory('conversationProfileService', ["$q", "$rootScope", "$stateParams", "profilesService", "comapiChatStore",
            function ($q, $rootScope, $stateParams, profilesService, comapiChatStore) {

                var anonRegex = /anon_[A-Za-z0-9]{8}-[A-Za-z0-9]{4}-[A-Za-z0-9]{4}-[A-Za-z0-9]{4}-[A-Za-z0-9]{12}/;

                $rootScope.$on("profile:patched", function (event, profile) {

                    comapiChatStore.getConversations()
                        .then(function (conversations) {

                            var affected = [];
                            conversations.forEach(function (conversation) {

                                var profileId = getParticipantProfileId(conversation);

                                if (profileId === profile.id) {
                                    affected.push(conversation);
                                }

                            });

                            if (affected.length) {
                                _applyProfileDataFromPatch(affected, profile);
                            }
                        });
                });


                var profileApplicationStatus = {
                    pending: "pending",
                    applied: "applied",
                    stale: "stale"
                }

                /**
                 * @param {*} conversations 
                 */
                function formatQuery(conversations) {
                    var query = "";

                    for (var i = 0; i < conversations.length; i++) {
                        var conversation = conversations[i];

                        var profileId = getParticipantProfileId(conversation);
                        query += "id[]=" + profileId + "&";
                    }

                    return query;
                }

                /**
                 * 
                 * @param {*} conversation
                 */
                function getParticipantProfileId(conversation) {
                    var profileId;

                    angular.forEach(conversation.participants, function (participant) {
                        if (participant.role === "participant") {
                            profileId = participant.id;
                        }
                    });

                    return profileId;
                }

                /**
                 * Build a name based on these rules
                 * firstName lastName
                 * email
                 * twitterUsername
                 * phoneNumber
                 * Anonymous User
                 * @param {*} profileData 
                 */
                function formatName(profileData) {
                    var firstName = profileData.firstName;
                    var lastName = profileData.lastName;

                    if (firstName && lastName) {
                        return firstName + " " + lastName;
                    } else if (firstName) {
                        return firstName;
                    } else if (lastName) {
                        return lastName;
                    } else if (profileData.email) {
                        return profileData.email;
                    }
                    else if (profileData.twitterUsername) {
                        return profileData.twitterUsername;
                    }
                    else if (profileData.phoneNumber) {
                        return profileData.phoneNumber;
                    }
                    else {
                        return anonRegex.test(profileData.id) ? "Anonymous User" : profileData.id;
                    }
                }

                /**
                 * 
                 * @param {*} profile 
                 */
                function mapProfile(profileData) {
                    return {
                        name: formatName(profileData),
                        avatar: profileData.profilePicture || "./assets/img/avatar.svg"
                    };
                }

                /**
                 * 
                 * @param {*} arr 
                 * @param {*} iteratorFn 
                 */
                function eachSeries(arr, iteratorFn) {
                    return arr.reduce(function (p, item) {
                        return p.then(function () {
                            return iteratorFn(item);
                        });
                    }, $q.resolve());
                };

                /**
                 * Method to patch user's avatar from their profile (or return the default value) into the conversation 
                 * @param {Object[]} conversations - array of conversations
                 * @returns {Object[]} returns the conversations
                 */
                function _bulkApplyProfileData(conversations) {

                    // dictionary of {profileId: {avatar: "?", name: "?"}
                    var profileCache = {};

                    return profilesService.getProfilesWithQueries($stateParams.pickedApiSpaceId, formatQuery(conversations), true)
                        .then(function (profiles) {

                            return eachSeries(profiles, function (profile) {
                                if (profile && profile._relationships && profile._relationships.primaryId) {
                                    return profilesService.getProfile($stateParams.pickedApiSpaceId, profile._relationships.primaryId, true)
                                        .then(function (parentProfile) {
                                            if (parentProfile) {
                                                profileCache[profile.id] = mapProfile(parentProfile);
                                            } else {
                                                profileCache[profile.id] = mapProfile(profile);
                                            }
                                            return $q.resolve(profileCache[profile.id]);
                                        });
                                }
                                else {
                                    profileCache[profile.id] = mapProfile(profile);
                                    return $q.resolve(profileCache[profile.id]);
                                }
                            });
                        })
                        .then(function () {

                            for (var i = 0; i < conversations.length; i++) {
                                var conversation = conversations[i];

                                var profileId = getParticipantProfileId(conversation);

                                if (profileCache[profileId]) {
                                    conversation.participantAvatar = profileCache[profileId].avatar;
                                    conversation.participantName = profileCache[profileId].name;
                                } else {
                                    conversation.participantAvatar = "./assets/img/avatar.svg";
                                    conversation.participantName = profileId;
                                }

                                conversation.profileApplicationStatus = profileApplicationStatus.applied;

                            }

                            return $q.resolve(conversations);
                        });

                }


                /**
                 * Method to patch user's avatar from their profile (or return the default value) into the conversation 
                 * @param {Object[]} conversations - array of conversations
                 * @returns {Object[]} returns the conversations
                 */
                function _applyProfileDataFromPatch(conversations, profile) {


                    for (var i = 0; i < conversations.length; i++) {
                        var conversation = conversations[i];

                        let name = formatName(profile)
                        conversation.participantName = name;
                    }
                }

                /**
                 * 
                 * @param {*} conversation 
                 * @param {*} profileId 
                 * @param {*} primaryProfileId 
                 */
                function applyProfileDataFromPrimary(conversations, profileId, primaryProfileId) {

                    return profilesService.getProfileDirect($stateParams.pickedApiSpaceId, primaryProfileId, true)
                        .then(function (parentProfile) {

                            var mapped = mapProfile(parentProfile);

                            return eachSeries(conversations, function (conversation) {

                                if (getParticipantProfileId(conversation) === profileId) {
                                    conversation.participantAvatar = mapped.avatar;
                                    conversation.participantName = mapped.name;
                                    conversation.profileApplicationStatus = profileApplicationStatus.applied;
                                }
                                return $q.resolve(conversation);

                            });
                        });
                }


                var nextBatch = [];

                function _applyProfileData() {

                    // at the point of this getting called, we want to reset nextBatch
                    var thisBatch = nextBatch.slice();
                    nextBatch = [];

                    _bulkApplyProfileData(thisBatch)
                }

                // make a debounced version of _applyProfileData that requires a  200 Ms timeout and gets triggered on the trailing edge
                var applyProfileData = COMAPI_CHAT.Utils.debounce(_applyProfileData, 200);

                var fac = {
                    /**
                     *
                     */
                    getParticipantProfileId: getParticipantProfileId,
                    /**
                     *
                     */
                    applyProfileDataFromPrimary: applyProfileDataFromPrimary,

                    /**
                     * Method to patch user's avatar from their profile (or return the default value) into the conversation 
                     * @param {any[]} conversations - array of conversations
                     * @param {number} index - the offset into the conversations array
                     * @returns {Object[]} returns the conversations
                     */
                    applyProfileData: function (conversation) {

                        if (conversation.profileApplicationStatus === undefined) {
                            // batch up the records and call the debounced function. 
                            // THis will effectively queue up a nice lot of queries and be efficient
                            nextBatch.push(conversation);
                            conversation.profileApplicationStatus = profileApplicationStatus.pending;

                            applyProfileData();
                        }
                    },
                };

                return fac;
            }]);

})(window.angular);

